import { DataBean } from "../DataBean";

export class QualityInspectionProductRamdom extends DataBean {

  public async getQualityInspectionProductRamdomCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionProductRamdomCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionProductRamdomRender(page: number, rows: number, properties: any, fromDate: any, uptoDate: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionProductRamdomRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, fromDate, uptoDate]
    );
  }

  public async deleteQualityInspectionProductRamdom(idqualityinspectionproductramdom: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionProductRamdom_Number", [idqualityinspectionproductramdom]);
  }

  public async updateQualityInspectionProductRamdom(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionProductRamdom_updateQualityInspectionProductRamdom_com.orange.finance.processcontract.bean.QualityInspectionProductRamdom",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionProductRamdom",
        },
      ]
    );
  }
}
